import styled from '@emotion/styled';
import { breakpoint, colors, spacing, typography } from '../../../themes';

export const DropdownButtonStyled = styled.button<{ disabled: boolean; rounded?: boolean }>`
  display: inline-flex;
  padding: 4px 4px 4px ${(props) => (props.rounded ? '4px' : '8px')};
  align-items: center;
  gap: 4px;
  cursor: pointer;
  border-radius: ${(props) => (props.rounded ? '50%' : '4px')};
  border: ${(props) => (props.rounded ? 'none' : `1px solid ${colors.monochrome.grey20}`)};
  ${typography.body.large};
  color: ${colors.primary.grey};

  background: ${(props) => {
    if (props.rounded) return 'transparent';
    if (props.disabled) return colors.monochrome.grey10;

    return colors.base.white;
  }};

  &:hover {
    background: ${(props) =>
      props.rounded ? `oklch(from ${colors.base.black} l c h / 0.1);` : colors.background.grey};
  }

  @media (max-width: ${breakpoint.medium}px) {
    width: 100%;
  }
`;

export const FloatingContainer = styled.div<{ containerMinWidth?: string }>`
  display: flex;
  min-width: ${(props) => props.containerMinWidth || '150px'};
  max-height: 300px;
  flex-direction: column;
  align-items: flex-start;
  z-index: 100;
  border-radius: 4px;
  border: 1px solid ${colors.monochrome.grey20};
  box-shadow: 0 4px 8px 0 rgba(51, 51, 51, 0.08);
  background-color: white;
`;

export const ItemsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  scrollbar-width: 8px;
  scrollbar-color: ${colors.monochrome.grey40} ${colors.base.white};

  &::-webkit-scrollbar {
    width: 8px;
  }
`;

export const Item = styled.button`
  unset: all;
  ${typography.body.large};
  color: ${colors.base.black};
  width: 100%;
  padding: ${spacing.xxsmall} ${spacing.xmsmall};
  cursor: pointer;
  text-align: left;
  border: 0;
  background-color: ${colors.base.white};
  display: flex;
  flex-direction: row;
  gap: ${spacing.xsmall};
  align-items: center;
  justify-content: space-between;

  &:focus {
    border: 2px solid ${colors.primary.blue};
  }

  &:hover {
    background: ${colors.background.grey};
  }
`;

export const SearchWrapper = styled.div`
  width: 100%;
  padding: ${spacing.xmsmall};
  box-sizing: border-box;
  border-bottom: 1px solid ${colors.monochrome.grey20};
`;

export const NoWrap = styled.span`
  white-space: nowrap;
`;

export const ChevronWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
